import React from 'react';
import { CollapseFilterWrapper } from '../../../components/sidebar-filters/CollapseFilterWrapper';
import { ControlProviderFilterSelect } from '../../../components/sidebar-filters/filter-select/ControlProviderFilterSelect';
import { VenStatusFilterSelect } from '../../../components/sidebar-filters/filter-select/VenStatusFilterSelect';
import { VenTypeFilterSelect } from '../../../components/sidebar-filters/filter-select/VenTypeFilterSelect';
import { useSidebarFilterOptionsContext } from '../../energyUsageData/sidebar/context/SidebarFilterOptionsContext';
import { ICustomerVenSidebarFilters, useCustomerVenSidebarFiltersContext } from './CustomerVenSidebarFiltersContext';

export const CustomerVenFilterKeys = {
    // Filters
    status: 'status',
    type: 'type',
    controlProviderId: 'control_providers_id',
} as const;

export type TCustomerVenFilterKey = (typeof CustomerVenFilterKeys)[keyof typeof CustomerVenFilterKeys];

export const CustomerVenFilterLabels = {
    [CustomerVenFilterKeys.status]: 'VEN Status',
    [CustomerVenFilterKeys.type]: 'VEN Type',
    [CustomerVenFilterKeys.controlProviderId]: 'Control Provider',
} as const;

interface ICustomerVenSidebarFiltersProps {
    onFilterChange: (filters: ICustomerVenSidebarFilters) => void;
}

export const CustomerVenSidebarFilters: React.FC<ICustomerVenSidebarFiltersProps> = ({ onFilterChange }) => {
    const { filters, handleFilterChange } = useCustomerVenSidebarFiltersContext();
    const { isLoading: isFiltersLoading, controlProviderOptions, venTypeOptions, venStatusOptions } = useSidebarFilterOptionsContext();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto' }}>
            {/* Filters */}
            <CollapseFilterWrapper label="Filters">
                <ControlProviderFilterSelect
                    label={CustomerVenFilterLabels[CustomerVenFilterKeys.controlProviderId]}
                    value={filters[CustomerVenFilterKeys.controlProviderId]}
                    onChange={value => handleFilterChange(CustomerVenFilterKeys.controlProviderId, value)}
                    isLoading={isFiltersLoading}
                    options={controlProviderOptions}
                />
                <VenTypeFilterSelect
                    label={CustomerVenFilterLabels[CustomerVenFilterKeys.type]}
                    value={filters[CustomerVenFilterKeys.type] || null}
                    onChange={value => handleFilterChange(CustomerVenFilterKeys.type, value)}
                    options={venTypeOptions}
                />
                <VenStatusFilterSelect
                    label={CustomerVenFilterLabels[CustomerVenFilterKeys.status]}
                    value={filters[CustomerVenFilterKeys.status] || null}
                    onChange={value => handleFilterChange(CustomerVenFilterKeys.status, value)}
                    options={venStatusOptions}
                />
            </CollapseFilterWrapper>
        </div>
    );
};
